/**
 * Footer stamp for DEV GKE builds (Outlook task pane + AIRA admin).
 * Live GKE / Cloud Run omit the env flag so this returns null — absence of the
 * stamp is how Live is distinguished from DEV.
 */
export function formatDevBuildLabel(input) {
    if (!isGkeDevStampEnabled(input.env, input.enabled))
        return null;
    const sha = input.sha?.trim().slice(0, 7);
    const builtAt = formatBuiltAt(input.builtAt?.trim() ?? '');
    return ['GKE DEV', sha || null, builtAt || null].filter(Boolean).join(' · ');
}
function isGkeDevStampEnabled(env, enabled) {
    const normalized = env?.trim().toLowerCase();
    if (normalized === 'gke-dev' || normalized === 'dev')
        return true;
    return enabled === true || enabled === 'true';
}
function formatBuiltAt(raw) {
    if (!raw)
        return '';
    const ms = Date.parse(raw);
    if (Number.isNaN(ms))
        return raw;
    const d = new Date(ms);
    const yyyy = d.getUTCFullYear();
    const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(d.getUTCDate()).padStart(2, '0');
    const hh = String(d.getUTCHours()).padStart(2, '0');
    const min = String(d.getUTCMinutes()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd} ${hh}:${min} UTC`;
}
//# sourceMappingURL=devBuildLabel.js.map